import styled from "styled-components";

import {
  alignItemsCenter,
  circle,
  flexColumn,
  pseudo,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledFullSurgicalHistoryModal = styled.div`
  padding-bottom: 1rem;

  .timeline {
    ${flexColumn}
    gap: 2rem;
    margin-bottom: 2rem;

    &-item {
      ${alignItemsCenter}
      gap: 1rem;

      &:first-child {
        .decor {
          border-color: var(--clr-accent);
        }
      }

      &:last-child {
        .decor::before {
          content: none;
        }
      }

      @media screen and (pointer: fine) {
        .delete-btn {
          opacity: 0;
          transition: opacity 0.2s;
        }

        &:hover {
          .delete-btn {
            opacity: 1;
          }
        }
      }

      .date {
        font-size: ${rem(13)};
        color: var(--clr-gray-400);
        width: 7ch;
      }

      .decor {
        position: relative;
        ${circle(rem(15))}
        background-color: var(--clr-white);
        border: 2px solid var(--clr-gray-300);
        z-index: 1;

        &::before {
          ${pseudo}
          overflow: hidden;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          ${size("1px", rem(40))}
          background-color: var(--clr-gray-300);
          z-index: -1;
        }
      }

      .name {
        font-size: ${rem(14)};
        text-transform: capitalize;
        /* word-wrap: break-word;
        width: 35ch;
        line-height: 1.2; */
      }
    }
  }
`;
